<template>
  <v-select
    :label="$t('components.common.category')"
    :items="categories"
    item-text="description"
    item-value="id"
    return-object
    class="mt-5"
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content class="font-weight-bold text--secondary" v-if="item.isMainCategory">
        <v-list-item-title>
          {{ item.description }}
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-content v-if="!item.isMainCategory">
        <v-list-item-title>{{ item.description }} </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { mapStores } from 'pinia';
import { useLookupStore } from '../../stores/LookupStore';
import { useUserStore } from '../../stores/UserStore';

export default {
  props: {
    value: Object,
  },

  data() {
    return {
      categories: [],
    };
  },

  computed: {
    ...mapStores(useLookupStore, useUserStore),
  },

  mounted() {
    if (!this.userStore.hasSelectedCompanyManyCategories) {
      this.categories = this.getCategoriesForSingleMainCategory();
      return;
    }

    this.categories = this.getCategoriesForMultipleMainCategories();
  },

  methods: {
    getCategoriesForSingleMainCategory() {
      const mainCategoryForCompany = this.userStore.selectedCompany.main_categories[0];
      return this.lookupStore.categoriesByMainCategory({ id: mainCategoryForCompany });
    },

    getCategoriesForMultipleMainCategories() {
      const addDashAsPrefixOnCategoryDescription = (category) => ({...category, description: ` - ${category.description}`});

      return this.userStore.selectedCompanyMainCategories
        .map((mcat) => ({ ...mcat, disabled: true, isMainCategory: true }))
        .reduce((acc, mcat) => {
          return [
            ...acc, 
            { ...mcat, id: 'mc_' + mcat.id }, 
            ...this.lookupStore.categoriesByMainCategory(mcat).map(addDashAsPrefixOnCategoryDescription)
          ];
        }, []);
    }
  },
};
</script>
